import {NgModule} from '@angular/core';

import {CommonModule} from '@angular/common';
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {HttpClientModule} from "@angular/common/http";
import {SafeUrlPipe} from "./pipes/safe-url.pipe";
import {AdsnComponentModule, AdsnMainModule} from "@adsn/angular-ui";


@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        SafeUrlPipe,
    ],
    exports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        HttpClientModule,
        NgbModule,
        SafeUrlPipe,
        AdsnMainModule,
        NgbTooltipModule,
        AdsnComponentModule
    ],
    providers: []
})
export class SharedModule {
}

